import { FunctionComponent } from "react"
import { Button, Card } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { Group } from "../data/models.interface"
import PrivateComponent from "./PrivateComponent"

interface ITenantsCard {}
const TenantsCard: FunctionComponent<ITenantsCard> = () => {
	const navigate = useNavigate()
	return (
		<Card className="mt-4">
			<Card.Header>Assign Keycards and Permissions</Card.Header>
			<Card.Body>
				<Card.Text>
					<ul>
						<li>Assign keycards to residents, employees, & vendors</li>
						<li>Assign roles and permissions to employees & vendors</li>
					</ul>
					<Button className="mt-4" onClick={() => navigate("/tenants")}>
						View Residents
					</Button>
					<br />
					<PrivateComponent groups={[Group.AccessControlManager, Group.AccessControlAdmin, Group.GlobalAdmin]}>
						<Button className="mt-4" onClick={() => navigate("/entities")}>
							View Employees & Vendors
						</Button>
					</PrivateComponent>
				</Card.Text>
			</Card.Body>
		</Card>
	)
}
export default TenantsCard
